<template>
  <div>
    <sPopover
      v-model="showMenu"
      :disabled="disabled"
      placement="bottom">
      <DatePicker
        class-name="period-dialog"
        :ma-datex="max_date"
        :min-date="min_date"
        :month.sync="date_month"
        :period.sync="date"
        :range="range"
        :with_allowed_dates="with_allowed_dates"
        @changeDate="saveDate"/>
      <DateField
        v-if="input"
        slot="reference"
        appimage
        class="data-field"
        :class=" (range ? 'range ' : '') + (custom_text_class || '') "
        :clearable="clearable"
        :disabled="disabled"
        :error="error"
        :label="$t(text_field_label)"
        :min_date_for="min_date_for"
        :min_error="error_message"
        :model.sync="value_format"
        :prefix="prefix"/>
      <DateChip
        v-else
        slot="reference"
        :class=" (range ? 'range ' : '') + (custom_text_class || '') "
        :clearable="clearable"
        data-qa="date_chip_from"
        :date="value_format"
        :disabled="disabled"
        :error="error"
        :error_text="error_message"
        :label="$t(text_field_label)"
        :prefix="prefix"
        @clear="$emit('update:value', null)"/>
    </sPopover>
  </div>
</template>

<script>
import DateChip from 'components/common/elements/DateChip.vue'
import DateField from 'components/common/inputs/DateField.vue'
import DatePicker from 'components/common/elements/DatePicker.vue'

import moment from 'moment'

export default {
  name: 'dateMenu',
  data() {
    return {
      showMenu: false,
    }
  },
  props: {
    value: [Object, String, Array],
    min_error: [Function, String, Boolean, Object],
    error: {
      type: Boolean
    },
    'date-month': String,
    changeDate: {
      type: Function,
    },
    min_date: String,
    min_date_for: String,
    max_date: String,
    custom_text_class: String,
    text_field_label: String,
    model: Boolean,
    /**
     * Учитывать арзрешенные даты (без выходных, праздников, ...)
     */
    with_allowed_dates: {
      type: Boolean
    },
    prefix: String,
    range: Boolean,
    clearable: Boolean,
    input: Boolean,
    disabled: {
      type: Boolean
    },
  },
  computed: {
    opened: {
      get() {
        return this.model
      },
      set(val) {
        this.$emit('update:model', val)
      }
    },
    date_month: {
      get() {
        return this.dateMonth
      },
      set(val) {
        this.$emit('update:dateMonth', val)
      }
    },
    date: {
      get() {
        return  this.range || !this.value ?  this.value : moment(this.value ).format('YYYY-MM-DD')
      },
      set(val) {
        this.$emit('update:value', val)
      }
    },
    error_message() {
      if ( this.min_error ) {
        let type = typeof this.min_error,
          date
        if ( type == 'string' ) {
          date = this.min_error
        } else if ( type == 'boolean' ) {
          return ''
        } else {
          date = `${this.$d(new Date(this.min_error), 'shortDate')}, ${this.$d(new Date(this.min_error), 'time')}`
        }
        return this.$t('Validate.WrongProposalsDate' ,
          {date , for: this.min_date_for })
      }
      return ''
    },
    value_format: {
      get() {
        if ( this.range && this.date ) {
          return moment(this.date[0]).format('DD.MM.YYYY') + ' - ' + moment(this.date[1]).format('DD.MM.YYYY')
        }
        if (!parseFloat(this.date)) {
          return null
        }
        if (  moment(this.date).isValid() ) {
          return moment(this.date).format('DD.MM.YYYY')
        }
        return ''
      },
      set(newValue) {
        if ( this.range ) {
          return this.date
        }
        if (!parseFloat( newValue ) ) {
          return this.date = newValue
        }
        this.date =  moment(newValue, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    },
  },
  methods: {
    saveDate(date) {
      this.showMenu = false
      if ( this.changeDate ) {
        return this.changeDate(date)
      }
      this.$refs.menu?.save(date)
    }
  },
  components: {
    DateChip,
    DateField,
    DatePicker
  }
}
</script>
<style lang="scss" scoped>
.data-field {
  width: 172px;
  max-width: 172px;
  &.range {
    width: auto;
    max-width: 216px;
  }
}
</style>
<style lang="scss">
.data-field {
  .masked-input {
    cursor: pointer;
  }
}
</style>
